import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { ProvinciaSelect } from 'sharedComponents/select'

const IdProvinciaFormGroup = ({ values, setValues, handleChange, idDepartamento, iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='PROVINCIA' htmlFor='select-idProvincia' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idProvincia'>
          {({ field }) => (
            <ProvinciaSelect
              {...field}
              idDepartamento={idDepartamento}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-idProvincia'
              onChange={e => {
                handleChange(e)
                values._idProvincia = e.target.value
                values._idDistrito = ''
                setValues(values)
              }}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(IdProvinciaFormGroup)
